export default __webpack_public_path__ + "static/media/Minimally-Invasive.816bfa4e.jpg";